import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { object, string } from 'yup'
import { Form } from 'semantic-ui-react'
import { useValidateForm } from '../../Common/Hooks/useValidateForm'
import { setPegiData } from '../Slice/PegiSlice'

export default function PegiForm () {
  const { t } = useTranslation()
  const { form: pegi, isLoading, isDirty } = useSelector((state) => state.pegi)
  const dispatch = useDispatch()

  const pegiSchema = object({
    name: string().required(t('generic.validation.name'))
  })
  const [errors, validate, handleChange] = useValidateForm(pegi, pegiSchema)

  const updateFormData = (data, isValid) => {
    dispatch(setPegiData({ data, isValid }))
  }

  useEffect(() => {
    validate(pegi)
  }, [isDirty])

  return (
    <Form autoComplete='off' loading={isLoading}>
      <Form.Input
        label={ t('generic.name') }
        placeholder={ t('generic.name') }
        name='name'
        required
        value={pegi.name}
        error={isDirty && errors.name}
        onChange={ handleChange(updateFormData) }
      />
    </Form>
  )
}
